module.exports = __webpack_public_path__ + "static/img/dq1.3f217fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq1.png
// module id = bb+8
// module chunks = 0